var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "createPost-container" }, [
    _c(
      "div",
      { staticClass: "createPost-main-container" },
      [
        _c("el-alert", {
          staticStyle: { "margin-bottom": "16px" },
          attrs: {
            type: "info",
            closable: false,
            "show-icon": "",
            title: "AIM Groups — Trainer / Trainee",
            description: _vm.$t("mobilityGroups.trainerTraineeInfo"),
          },
        }),
        _c(
          "el-card",
          { staticClass: "add-form-card", attrs: { shadow: "never" } },
          [
            _c(
              "div",
              {
                staticClass: "card-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v("Create / Update Group")])]
            ),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c("div", { staticClass: "form-label" }, [
                      _vm._v("Teacher"),
                    ]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "remote-method": _vm.searchTeacher,
                          filterable: "",
                          "default-first-option": "",
                          remote: "",
                          placeholder: "Search teacher by email / name",
                        },
                        model: {
                          value: _vm.teacherId,
                          callback: function ($$v) {
                            _vm.teacherId = $$v
                          },
                          expression: "teacherId",
                        },
                      },
                      _vm._l(_vm.teacherOptions, function (item, index) {
                        return _c("el-option", {
                          key: item.userId + index,
                          attrs: { label: item.label, value: item.userId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 16 } },
                  [
                    _c("div", { staticClass: "form-label" }, [
                      _vm._v("Students"),
                    ]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "remote-method": _vm.searchStudents,
                          filterable: "",
                          "default-first-option": "",
                          multiple: "",
                          remote: "",
                          placeholder: "Search students by email / name",
                        },
                        model: {
                          value: _vm.studentIds,
                          callback: function ($$v) {
                            _vm.studentIds = $$v
                          },
                          expression: "studentIds",
                        },
                      },
                      _vm._l(_vm.studentOptions, function (item, index) {
                        return _c("el-option", {
                          key: item.userId + index,
                          attrs: { label: item.label, value: item.userId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", loading: _vm.submitting },
                    on: { click: _vm.submitGroup },
                  },
                  [_vm._v(" Save Group ")]
                ),
                _c("el-button", { on: { click: _vm.resetForm } }, [
                  _vm._v("Reset"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-card",
          {
            staticClass: "relationships-card",
            staticStyle: { "margin-top": "20px" },
            attrs: { shadow: "never" },
          },
          [
            _c(
              "div",
              {
                staticClass: "card-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [
                _c("span", [_vm._v("Existing AIM Groups")]),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-refresh",
                      loading: _vm.listLoading,
                    },
                    on: { click: _vm.fetchGroups },
                  },
                  [_vm._v(" Refresh ")]
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.groups, border: "" },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "Teacher", "min-width": "220" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("div", { staticStyle: { "font-weight": "500" } }, [
                            _vm._v(
                              " " +
                                _vm._s(row.teacherFirstName) +
                                " " +
                                _vm._s(row.teacherLastName) +
                                " "
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(row.teacherEmail || row.teacherId) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Students", "min-width": "360" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.students && row.students.length
                            ? _c(
                                "div",
                                _vm._l(row.students, function (s) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: s.userId,
                                      staticStyle: { margin: "2px 4px" },
                                      attrs: {
                                        size: "small",
                                        closable: "",
                                        "disable-transitions": true,
                                      },
                                      on: {
                                        close: function ($event) {
                                          return _vm.handleRemoveStudent(row, s)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            s.firstName || s.lastName
                                              ? (
                                                  s.firstName +
                                                  " " +
                                                  s.lastName
                                                ).trim()
                                              : s.email || s.userId
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              )
                            : _c(
                                "span",
                                { staticStyle: { color: "#909399" } },
                                [_vm._v("No students")]
                              ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Count", width: "90", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [_vm._v(_vm._s(row.studentCount))]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Updated", width: "140" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                row.updatedAt
                                  ? _vm.formatDate(row.updatedAt)
                                  : "-"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "Actions", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openEditGroup(row)
                                },
                              },
                            },
                            [_vm._v(" Add Students ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "Add Students to Group",
              visible: _vm.editDialogVisible,
              width: "520px",
            },
            on: {
              "update:visible": function ($event) {
                _vm.editDialogVisible = $event
              },
            },
          },
          [
            _vm.editingGroup
              ? _c(
                  "div",
                  [
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _c("strong", [_vm._v("Teacher:")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.editingGroup.teacherFirstName) +
                          " " +
                          _vm._s(_vm.editingGroup.teacherLastName) +
                          " (" +
                          _vm._s(_vm.editingGroup.teacherEmail) +
                          ") "
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "form-label",
                        staticStyle: { "margin-top": "16px" },
                      },
                      [_vm._v("Students to add")]
                    ),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "remote-method": _vm.searchStudents,
                          filterable: "",
                          "default-first-option": "",
                          multiple: "",
                          remote: "",
                          placeholder: "Search students",
                        },
                        model: {
                          value: _vm.editStudentIds,
                          callback: function ($$v) {
                            _vm.editStudentIds = $$v
                          },
                          expression: "editStudentIds",
                        },
                      },
                      _vm._l(_vm.studentOptions, function (item, index) {
                        return _c("el-option", {
                          key: item.userId + index,
                          attrs: { label: item.label, value: item.userId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "span",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.editDialogVisible = false
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.editSubmitting },
                    on: { click: _vm.submitAddStudents },
                  },
                  [_vm._v(" Add ")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }